// Third party libraries
import Moment from 'moment';

export interface PaymentPlanInterface {
    discount: number;
    logo: any;
    maxStudentsToManage: number;
    periodicityText: string;
    planPrice: number;
    newPlanPrice: number;
    totalAmount: number;
};

// Esto esta fijo, pero hay que ponerlo dinámico con promociones que se creen desde el Admin
// Serían promociones adicionales a las generales que ya se le pueden poner a los planes
const offerExpireDate: string = Moment('16-10-2022', 'DD-MM-YYYY').format();

const getPromotionExpireDateString = (): string => offerExpireDate;

const exports = {
    getPromotionExpireDateString
};

export default exports;